const screenType = {
  onboarding: 'Onboarding',
  onboardingError: 'OnboardingError',
  andy: 'Andy',
  pyxir: 'Pyxir',
};

export default screenType;
